import React from 'react';
import PropTypes from 'prop-types';
import colors from 'hsl-shared-components/lib/Theme/colors';
import styled from 'styled-components';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const ButtonStyled = styled.a`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 28px;
  width: fit-content;
  height: 50px;
  background: #fffff;
  border: 1px solid #888888;
  border-radius: 50px;
  font-weight: 400;
  color: ${colors.primary.hslBlue};

  &:hover {
    cursor: pointer;
    background: ${colors.primary.hslWhite};
    border-color: ${colors.primary.hslBlueDark};
  }

  &:hover span {
    color: ${colors.primary.hslBlueDark};
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    letter-spacing: -0.5px;
    padding: 10.5px 28px;
  }
`;

const ButtonText = styled.span`
  font-size: 18px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 16px;
    letter-spacing: -0.02em;
    line-height: 19px;
  }
`;

const Button = ({ text, disabled, onClick }) => (
  <ButtonStyled onClick={disabled ? () => false : onClick}>
    <ButtonText>{text}</ButtonText>
  </ButtonStyled>
);

Button.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

Button.defaultProps = {
  disabled: false,
};

export default Button;
